import React, {useState} from "react"

import {Interaction, Interactive} from "./Interactive"
import {Pointer} from "./Pointer"

import {hsvaToHslString} from "../utils/convert"
import {round} from "../utils/round"

interface Props {
    height: string;
    width: string;
    hue: number;
    onChange: (newHue: {h: number}) => void;
}

const HueBase = ({height, hue, width, onChange}: Props) => {
    const [top, setTop] = useState(0.5)
    const handleMove = (interaction: Interaction) => {
        setTop(interaction.top)
        onChange({h: 360 * interaction.left})
    }

    return (
        <div className={"color-hue"} style={{height: height, width: width}}>
            <Interactive onMove={handleMove} aria-label="Hue" aria-valuetext={round(hue)}>
                <Pointer
                    left={hue / 360}
                    top={top}
                    color={hsvaToHslString({h: hue, s: 100, v: 100, a: 1})}
                />
            </Interactive>
        </div>
    )
}

export const Hue = React.memo(HueBase)
